import { CreateTimeSetQueryParamsType } from '@/common/queries/createTimeSet/createTimeSetQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const createTimeSetFunction = (params: CreateTimeSetQueryParamsType) => {
  return fetchApi.post(`/actions/${params.id}/time_set/`, params.data);
};
